import { BaseEntity } from "../system";

export interface IWilmaUser extends BaseEntity {
  status: WilmaUserStatus,
  forename: string;
  surname: string;
  username: string;
  email: string;
  hasPin: boolean;
  customerId: string;
  lastLogin: string;
  userClaims?: IWilmaUserClaim[];
}

export interface IWilmaUserClaim {
  type: string;
  value: string | null;
}

// Betty sets this claim to the id of the customer role the user is on, or "custom"
export const DASHBOARD_ROLE_CLAIM = "dashboardRoleId";

export interface IAddWilmaUser {
  forename: string;
  surname: string;
  // The part after the company prefix; the API adds the prefix
  username: string;
  email: string | null;
  password: string;
  roleId: string | null;
}

export interface IUpdateWilmaUser {
  userId: string;
  forename: string;
  surname: string;
  roleId: string | null;
}

export enum WilmaUserStatus {
  Archived,
  Disabled,
  Enabled,
  Invited
}

export interface IUserInviteProps {
  forename: string;
  surname: string;
  email: string;
  password: string;
  username: string;
  roleId?: string | null;
}
